import {AnalyticsEventHandler} from "../../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../../third-party-services/analytics/analytics-service";
import {BETTING_PROMOTION} from "../bettin-ptomotion.module.consts";
import {BettingPromotionDisplayAnalyticsEvent} from "../models/betting-promotion.display-analytics.event";
import {BaseAnalyticsEvent} from "../../../../../infrastructure/models/analytics/base-analytics-event";
import {BettingPromotionModuleState} from "../models/betting-promotion.module.state";

export class BettingPromotionDisplayAnalyticsHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  state: BettingPromotionModuleState;
  type = BETTING_PROMOTION.ACTION_TYPES.ANALYTICS.onDisplayHandler;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = BettingPromotionDisplayAnalyticsEvent
  }


  async action() {
    const params = {
      version: this.state.version,
      timesShown: this.state.popupVisibleCounter,
      bookieId: this.state.bookie.id,
      imageUrl: this.state.imageUrl,
      mainText: this.state.bookie.titleText.aliasName,
      secondaryTextTerm: this.state.bookie.ctaText.aliasName,
      bookieLinkUrl: this.state.buttonUrl
    };

    const clickEvent: BaseAnalyticsEvent = new this.eventType(params);

    this.analyticsService.createEvent(clickEvent);
  }
}
